<script setup>
import CheckCircleIcon from '@iconify-vue/ph/check-circle';
import InfoIcon from '@iconify-vue/ph/info-fill';
import WarningIcon from '@iconify-vue/ph/warning-fill';

const { type = 'primary' } = defineProps({
    type: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex items-center gap-2 rounded border px-3 py-1.5 text-sm"
        :class="{
            'border-blue-300 bg-blue-50 text-blue-700': type === 'primary',
            'border-green-300 bg-green-50 text-green-700': type === 'success',
            'border-yellow-300 bg-yellow-50 text-yellow-700':
                type === 'warning',
            'border-red-300 bg-red-50 text-red-700': type === 'danger',
        }"
    >
        <InfoIcon v-if="type === 'primary'" class="size-4" />
        <CheckCircleIcon v-if="type === 'success'" class="size-4" />
        <WarningIcon
            v-if="type === 'warning' || type === 'danger'"
            class="size-4"
        />
        <slot />
    </div>
</template>
